/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  getContribCondtition,
  saveContribCondition,
  deleteContribCondition,
} from 'api/pgads.js'

import CommonScreen from './CommonScreen'
import { Button, Input } from 'antd'
import styled from 'styled-components'

import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'

const TableTD = styled.td`
  text-align: end;
  max-width: 100px;
  width: 100px;
`

/* const monthOption = R.range(1, 13).map(i => ({
  key: i + '',
  value: i + '',
  text: i + '',
})) */

const headers = [
  strCol({
    ident: 'code',
    display: 'Id',
    isKey: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isRequired: true,
    width: 600,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Contributing Operating Condition'

const ContribCondition = _ => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Id :</TableTD>
            <td colSpan={1} style={{ maxWidth: '100px' }}>
              <Input
                style={{ maxWidth: '200px' }}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    code: e.target.value,
                  })
                }}
                maxLength={5}
              />
            </td>
            <TableTD>Description :</TableTD>
            <td colSpan={3}>
              <Input
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    description: e.target.value,
                  })
                }}
                max={1000}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
              <Button
                type="primary"
                onClick={() => onAdd(false)}
                style={{ marginLeft: '20px' }}
              >
                Add & Hide
              </Button>
              <Button
                type="danger"
                onClick={onCancel}
                style={{ marginLeft: '20px' }}
              >
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={saveContribCondition}
      retrieveTask={getContribCondtition}
      deleteTask={deleteContribCondition}
      altBy={d => d.code}
      autoRetrieve
      // sortOptions={[
      //   { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
      //   { ident: 'unit', display: 'Unit', sortOrder: 'asc' },
      // ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      widthOffset={550}
      // heightOffset={100}
      withDelete={false}
    />,
  ]
}

export default ContribCondition
